class Global {}
Global.NATIVE_BLOCK_SIZE = 64;
Global.PHYSICS_SCALE = Global.NATIVE_BLOCK_SIZE * 2;
Global.PHYSICS_SCALE_OG_FACTOR = 64 / Global.PHYSICS_SCALE;
Global.NATIVE_LEVEL_WIDTH = 16;
Global.NATIVE_LEVEL_HEIGHT = 10;
Global.NATIVE_RATIO = Global.NATIVE_LEVEL_WIDTH / Global.NATIVE_LEVEL_HEIGHT;

Global.MAX_VIEW_W_DIFFERENCE = 2;
Global.MAX_VIEW_H_DIFFERENCE = 2;

export default Global;
